<ngx-doc-viewer [url]="fullFilePath" [viewer]="viewFormat" style="width:100%;height:100vh;">
</ngx-doc-viewer>
